import { Select, SelectProps } from '../inputs/select';
import { PreferredTitle } from '@/api/api.schemas';
import { useTranslation } from '@/contexts/i18n-context';

export function PreferredTitleSelector({
  placeholder,
  className,
  ...restProps
}: Omit<SelectProps, 'options'>) {
  const { t } = useTranslation();

  return (
    <Select
      {...restProps}
      className={className}
      placeholder={placeholder}
      options={Object.values(PreferredTitle).map((title) => ({
        value: title,
        label: t(`preferredTitle.${title}`),
      }))}
    />
  );
}
